import { IonIcon } from "@ionic/react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, Card, Link, Typography } from "@mui/joy";
import axios from "axios";
import { logoWhatsapp } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getPaciente } from "../../apiClient/rutes/paciente";
import { loginPaciente } from "../../apiClient/rutes/usuarios";
import AnimatedBackground from "../../components/basicsComponents/AnimatedBackground/AnimatedBackground";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import ModalCambioContraseña from "../../components/formComponents/ModalCambioContrasena/ModalCambioContrasena";
import useTituloPagina from "../../hooks/tituloPagina";
import "../../theme/tech-variables.css";
import "./Login.css";

const LoginIonic = () => {
  const isMobile = window.innerWidth <= 768;
  const [cargando, setCargando] = useState(false);
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
    email: "",
  });
  const [recordarme, setRecordarme] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const [showModal, setShowModal] = useState(false);
  const [attemptCount, setAttemptCount] = useState(0);
  const history = useHistory();
  useTituloPagina();

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  const guardarCredenciales = (usuarioValue, passwordValue) => {
    if (recordarme) {
      localStorage.setItem("ppRecordarUsuario", usuarioValue);
      localStorage.setItem("ppRecordarPassword", passwordValue);
      localStorage.setItem("ppRecordarme", "true");
    } else {
      localStorage.removeItem("ppRecordarUsuario");
      localStorage.removeItem("ppRecordarPassword");
      localStorage.removeItem("ppRecordarme");
    }
  };

  const cargarCredencialesGuardadas = () => {
    const recordarmeGuardado = localStorage.getItem("ppRecordarme") === "true";
    if (recordarmeGuardado) {
      const usuarioGuardado = localStorage.getItem("ppRecordarUsuario") || "";
      const passwordGuardado = localStorage.getItem("ppRecordarPassword") || "";
      setRecordarme(true);
      setUsuario({
        usuario: usuarioGuardado,
        password: passwordGuardado,
        token: "",
        email: "",
      });
    }
  };

  const handleChangeRecordarme = (e) => {
    setRecordarme(e.target.checked);
  };

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP") || "");
    document.title = localStorage.getItem("tituloWeb") || document.title;
    sessionStorage.removeItem("ppUL");
    cargarCredencialesGuardadas();
  }, []);

  const loginPacienteHandler = async (usuarioInput, passwordInput) => {
    try {
      const token = await loginPaciente(usuarioInput, passwordInput);
      return token;
    } catch (error) {
      setErrorPassword(true);
      const mensajePorDefecto = "Error al consultar los datos del paciente. Verifique si el usuario y contraseña están registrados.";
      setMsjErrorPassword(mensajePorDefecto);

      let mensajeError = mensajePorDefecto;
      const mensajesNoUtiles = ["error", "error object", "[object object]"];

      if (error?.response?.data) {
        if (typeof error.response.data === "string") {
          const dataMsg = error.response.data.trim();
          if (dataMsg && !mensajesNoUtiles.includes(dataMsg.toLowerCase())) {
            mensajeError = dataMsg;
          }
        } else if (typeof error.response.data.message === "string") {
          const dataMessage = error.response.data.message.trim();
          if (dataMessage && !mensajesNoUtiles.includes(dataMessage.toLowerCase())) {
            mensajeError = dataMessage;
          }
        }
      } else if (typeof error?.message === "string") {
        const errorMessage = error.message.trim();
        if (errorMessage && !mensajesNoUtiles.includes(errorMessage.toLowerCase())) {
          mensajeError = errorMessage;
        }
      }

      mostrarNotificacion(true, mensajeError, "rojo");
    }
  };

  const obtenerPacienteHandler = async (token, documento) => {
    try {
      const data = await getPaciente(documento, token);
      return {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
    } catch (error) {
      mostrarNotificacion(true, "Se produjo un error al intentar consultar los datos del paciente", "rojo");
    }
  };

  const handleClickLogin = async () => {
    setCargando(true);
    if (usuario.usuario !== "" && usuario.password !== "") {
      const token = await loginPacienteHandler(usuario.usuario, usuario.password);
      if (token) {
        const paciente = await obtenerPacienteHandler(token, usuario.usuario);
        if (paciente) {
          mostrarNotificacion(true, "Sesión iniciada correctamente", "verde");
          setUsuario(paciente);
          sessionStorage.setItem("ppUL", JSON.stringify(paciente));
          history.push("/portal/Inicio");
        }
      }
    } else {
      if (usuario.usuario !== "") setErrorUsuario(true);
      if (usuario.password !== "") {
        setErrorPassword(true);
        setMsjErrorPassword("Debe ingresar su contraseña");
      }
    }
    setCargando(false);
  };

  const handleClickSubmit = () => {
    guardarCredenciales(usuario.usuario, usuario.password);
    handleClickLogin();
  };

  const handleChangeUsuario = (e) => {
    const value = e.target.value;
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorUsuario(false);
    setUsuario({ ...usuario, usuario: filteredValue });
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    setErrorPassword(false);
    setUsuario({ ...usuario, password: value });
  };

  const handlePasswordChange = async () => {
    try {
      const baseUrl = (urlAxioPP || localStorage.getItem("urlAxioPP") || "").replace(/\s+/g, "");
      const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
      const recoveryUrl = `${window.location.origin}/RecoveryPass/####`;
      const response = await axios.post(`${normalizedBaseUrl}Usuarios/OlvideMiContrasenia`, {
        Documento: usuario.usuario,
        URL: recoveryUrl,
        Mail: usuario.email,
      });

      if (response.status === 200) {
        alert("Solicitud de cambio de contraseña enviada. Revisa tu email.");
        setShowModal(false);
        setAttemptCount(0);
      }
    } catch (error) {
      if (attemptCount < 2) {
        alert("Dirección de correo incorrecto o no existe en la base de datos. Intente nuevamente.");
        setAttemptCount(attemptCount + 1);
      } else {
        alert(
          "El mail ingresado es incorrecto. Debe comunicarse telefónicamente con la clínica para actualizarlo. Caso contrario, NO podrá recuperar su contraseña. Será redirigido al inicio.",
        );
        setShowModal(false);
        setAttemptCount(0);
        history.push("/Login");
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "3541-422420";
    navigator.clipboard.writeText(phoneNumber);
    mostrarNotificacion(true, "Se ha copiado el numero de telefono a su portapapeles", "");
  };

  return (
    <div className="tech-login-container">
      <div className="tech-login-background"></div>
      <AnimatedBackground />

      <Card
        className="tech-login-card tech-card-main"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <div
          className="tech-login-left tech-login-left-styled"
          style={{
            flex: isMobile ? "auto" : "0.6",
            borderRight: isMobile ? "none" : "1px solid rgba(255, 255, 255, 0.2)",
            order: isMobile ? 1 : 0,
          }}
        >
          <div className="tech-decorative-pattern"></div>
          <div className="tech-content-wrapper">
            <div className="tech-logo-container">
              <img alt="Logo clinica" src="assets/icon/logo-cuadrado.png" className="" />
            </div>

            <Typography className="tech-left-title">Portal del Paciente</Typography>

            {!isMobile && (
              <Typography className="tech-left-title">
                Te damos la bienvenida a tu espacio de salud en Clínica Santa Lucía. Gestioná tus turnos, actualizá tus datos y comunicate con
                nosotros de manera fácil, rápida y segura, todo en un solo lugar.
              </Typography>
            )}
          </div>
        </div>

        <div
          className="tech-login-right tech-login-right-styled"
          style={{
            flex: isMobile ? "auto" : 1,
            flexDirection: "column",
            justifyContent: "center",
            order: isMobile ? 2 : 0,
          }}
        >
          {isMobile && (
            <div className="tech-mobile-header">
              <img alt="Logo clinica" src="assets/icon/logo-cuadrado.png" className="tech-mobile-header-logo" />
            </div>
          )}

          <Typography
            className="tech-right-title"
            style={{
              background: "var(--gradient-primary)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              fontFamily: "var(--font-display)",
              fontWeight: 600,
              fontSize: "clamp(1.1rem, 2.5vw, 1.3rem)",
              marginBottom: "clamp(1.5rem, 3vh, 2rem)",
              textAlign: "center",
              letterSpacing: "-0.02em",
            }}
          >
            Ingresa tus credenciales
          </Typography>

          <form className="tech-login-form" noValidate autoComplete="off">
            <div>
              <label className="tech-input-label">Documento</label>
              <input
                className={`tech-input ${errorUsuario ? "error" : ""}`}
                type="text"
                placeholder="Ingrese su documento..."
                value={usuario.usuario}
                onChange={handleChangeUsuario}
              />
              {errorUsuario && <div className="tech-error-message">Por favor ingrese un documento válido</div>}
            </div>

            <div className="tech-password-wrapper">
              <label className="tech-input-label">Contraseña</label>
              <input
                className={`tech-input tech-password-input-styled ${errorPassword ? "error" : ""}`}
                type={blnVerPassword ? "text" : "password"}
                placeholder="Ingrese su contraseña..."
                value={usuario.password}
                onChange={handleChangePassword}
                style={{
                  paddingRight: window.innerWidth <= 767 ? "35px" : "40px",
                }}
              />
              <Button
                onClick={handleChangeVisibilityOfPassword}
                type="button"
                variant="plain"
                color="neutral"
                size="sm"
                className="password-toggle-btn"
                sx={{
                  position: "absolute",
                  right: window.innerWidth <= 767 ? "4px" : "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  minWidth: window.innerWidth <= 767 ? "20px" : "24px",
                  minHeight: window.innerWidth <= 767 ? "20px" : "24px",
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "var(--color-text-secondary)",
                  zIndex: 10,
                  "&:hover": {
                    backgroundColor: "rgba(102, 126, 234, 0.1)",
                    color: "var(--color-primary)",
                  },
                }}
              >
                {blnVerPassword ? <Visibility /> : <VisibilityOff />}
              </Button>
              {errorPassword && <div className="tech-error-message">{msjErrorPassword}</div>}
              {!errorPassword && (
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: "var(--color-text-secondary)",
                    marginTop: "4px",
                    paddingLeft: "4px",
                  }}
                >
                  <div>Si no cambió su contraseña, ingrese su número de documento.</div>
                  {/*<div>
                    ¿Desea cambiar su contraseña?{" "}
                    <Link
                      component="button"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowModal(true);
                      }}
                      underline="hover"
                      color="primary"
                      sx={{ fontSize: "0.75rem" }}
                    >
                      Haga click AQUI
                    </Link>
                  </div>*/}
                </div>
              )}
            </div>

            <button className="tech-button" type="button" onClick={handleClickSubmit} disabled={cargando}>
              {cargando ? "Ingresando..." : "Ingresar"}
            </button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "var(--spacing-sm)",
                marginTop: "var(--spacing-md)",
              }}
            >
              <input
                type="checkbox"
                id="remember"
                checked={recordarme}
                onChange={handleChangeRecordarme}
                style={{
                  accentColor: "var(--color-primary)",
                  transform: "scale(1.1)",
                }}
              />
              <label
                htmlFor="remember"
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-text-secondary)",
                  cursor: "pointer",
                }}
              >
                Recordarme
              </label>
            </div>

            <div className="tech-register-info">
              <Typography className="tech-help-text">¿Todavía no tienes cuenta?</Typography>

              <Typography className="tech-whatsapp-info-text">Primera vez con nosotros? Regístrate por WhatsApp.</Typography>
              <a
                href="https://api.whatsapp.com/send?phone=+5493516194580&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClickCopiarTelefono}
                className="tech-whatsapp-link"
              >
                <IonIcon icon={logoWhatsapp} size="small" />
                Registrarse
              </a>
            </div>
          </form>
        </div>
      </Card>

      <div className="tech-login-footer">
        <Link className="tech-footer-link" href="https://www.gacitua.com.ar/" target="_blank" rel="noopener noreferrer">
          <Typography sx={{ color: "inherit" }}>Powered by</Typography>
          <img src="assets/icon/logoGacitua.png" alt="logo gacitua y asociados" width={20} height={20} className="tech-footer-logo-img" />
          <Typography sx={{ color: "inherit", fontWeight: "500" }}>Gacitua & Asociados</Typography>
        </Link>
      </div>

      <CustomToast
        openToast={toast.open}
        onDidDismiss={() => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />

      {cargando && (
        <div className="tech-loading-overlay">
          <div className="tech-loading-spinner"></div>
        </div>
      )}

      <ModalCambioContraseña
        isOpen={showModal}
        usuario={usuario}
        onClose={handleCloseModal}
        setUsuario={setUsuario}
        handlePasswordChange={handlePasswordChange}
      />
    </div>
  );
};

export default LoginIonic;
